import React from "react";
import { Col, Row } from "antd";
import { Controller } from "react-hook-form";
import ProfileForm from "../../../../../components/profile-form/profile-form";

const InstituteSupportingDoc = ({ control, isEditMode }) => {
  return (
    <Row style={{ margin: "20px 0" }} gutter={[32, 16]}>
      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="accrediation_certificate"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Upload
              inputLabel="Accreditation Certificate"
              isEdit={isEditMode}
              value={field?.value}
              handleBeforeUpload={(file) => {
                field.onChange(file);
                return false;
              }}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="operating_license"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Upload
              inputLabel="Operating License"
              isEdit={isEditMode}
              value={field?.value}
              handleBeforeUpload={(file) => {
                field.onChange(file);
                return false;
              }}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="additional_document"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Upload
              inputLabel="Additional Documents"
              isEdit={isEditMode}
              value={field?.value}
              handleBeforeUpload={(file) => {
                field.onChange(file);
                return false;
              }}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="logo"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Upload
              inputLabel="School Stamp/Seal"
              isEdit={isEditMode}
              value={field?.value}
              handleBeforeUpload={(file) => {
                field.onChange(file);
                return false;
              }}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col xs={24} sm={24} md={24} lg={12}>
        <Controller
          name="letter_head"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ProfileForm.Upload
              inputLabel="Letter Head"
              isEdit={isEditMode}
              value={field?.value}
              handleBeforeUpload={(file) => {
                field.onChange(file);
                return false;
              }}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default InstituteSupportingDoc;
